import { template } from "@ember/template-compiler";
import title from 'ember-page-title/helpers/page-title';
import Route from 'ember-route-template';
import TodoList from 'todomvc/components/todo-list';
export default Route(template(`
		{{title "Completed"}}

		<TodoList @todos={{@model.todos}} />
	`, {
    eval () {
        return eval(arguments[0]);
    }
}));
